import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator';
import { Action, State as StateClass } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import { ADD_TOAST_MESSAGE as addToastMessage } from 'vuex-toast';
import { State } from '@/store/models';
import { titleTemplate } from '@/helpers/meta/title-template';
import { ValidationObserver } from 'vee-validate';
import FormInput from '@/components/common/form-elements/FormInput.vue';
import * as MUTATIONS from '@/store/constants';

@Component({
  components: {
    ValidationObserver,
    FormInput,
  },
})

export default class Reset extends Vue {
  @Prop() isAuthPage!: boolean;

  metaInfo(): MetaInfo {
    return {
      title: titleTemplate(this.$t('meta.reset.title').toString()),
    };
  }

  email: string = '';

  @Action sendResetPassword!: Function;
  @Action(addToastMessage) addToastMessage!: Function;
  @Action openModal!: Function;

  @StateClass auth!: State['auth'];

  @Ref('form') readonly form!: InstanceType<typeof ValidationObserver>;

  @Watch('auth', { deep: true })
  onUserChanged(newAuth: State['auth'], oldAuth: State['auth']): void {
    if (newAuth
      && oldAuth
      && oldAuth.action
      && oldAuth.action === MUTATIONS.RESET_PASSWORD_PROCESSING
      && oldAuth.action !== newAuth.action) {
      // Notification
      this.addToastMessage({
        text: newAuth.action === MUTATIONS.RESET_PASSWORD_SUCCESS
          ? `${this.$t('auth.reset.emailSent')}. ${this.$t('auth.reset.pleaseCheckInbox')}.`
          : newAuth.error,
        type: newAuth.action === MUTATIONS.RESET_PASSWORD_SUCCESS ? 'success' : 'danger',
      });

      // Reset form to initial state, and prevent
      // showing validation errors ('... is required')
      if (newAuth.action === MUTATIONS.RESET_PASSWORD_SUCCESS) {
        this.email = '';
        this.$nextTick((): void => {
          this.form.reset();
        });
      }
    }
  }
}
